import {
  //CHECK_HEALTH_SUCCESS,
  GET_CHATS_SUCCESS,
  SEND_CHAT_MESSAGE_SUCCESS,
  GET_CHAT_MESSAGES_SUCCESS,
  UPLOAD_CHAT_ATTACHMENT_SUCCESS,
  DELETE_CHAT_ATTACHMENT_SUCCESS,
  UPDATE_CHAT_MESSAGE_SUCCESS,
  CHECK_ATTACHMENT_STATUS_SUCCESS,
  CHAT_DRAWER_OPEN_SUCCESS,
  SET_CHAT_ID,
  FINAL_TOOL_SUCCESS,
  LLM_SET_CHAT_CONTENT,
} from './type'

// eslint-disable-next-line import/no-anonymous-default-export
export default function (
  state = {
    chatList: [],
    chatContent: [],
    chatId: null,
    attachments: [],
    drawerOpen: true,
    errorOccurred: {
      error: false,
      message: '',
    },
  },
  action,
) {
  const { payload, type } = action
  switch (type) {
    case GET_CHATS_SUCCESS:
      return {
        ...state,
        chatList: payload.response.reverse(),
      }
    case SEND_CHAT_MESSAGE_SUCCESS:
      const chat = payload.response
      const chatIdFromResponse = chat.chatId
      const subject = chat.content.subject ? chat.content.subject : null

      const currentUrl = new URL(window.location.href)
      const collectionId = currentUrl.searchParams.get('collectionId')

      const newUrl = `/create-course-with-chat?collectionId=${collectionId}&chatId=${chat.chatId}`

      if (state.chatId == null && chat.chatId != null) {
        window.history.pushState({}, '', newUrl)
      }

      return {
        ...state,
        chatContent: [...state.chatContent, chat],
        chatId: state.chatId == null ? chatIdFromResponse : state.chatId,
        chatList:
          state.chatId == null && chat.chatId != null
            ? [
                {
                  chatId: chatIdFromResponse,
                  subject: subject,
                },
                ...state.chatList,
              ]
            : subject != null && chat.chatId == state.chatId
            ? state.chatList.map(chat => {
                if (chat.chatId === state.chatId) {
                  return {
                    ...chat,
                    subject: subject,
                  }
                }
                return chat
              })
            : state.chatList,
      }

    case GET_CHAT_MESSAGES_SUCCESS:
      return {
        ...state,
        chatId: payload.response.chatId,
        chatContent: [...payload.response.messages],
        attachments: [...payload.response.attachments],
      }
    case UPDATE_CHAT_MESSAGE_SUCCESS:
      return state
    case UPLOAD_CHAT_ATTACHMENT_SUCCESS:
      const fileName = payload.fileName
      const fileId = payload.response.attachment_id
      const currentChatId = state.chatId

      return {
        ...state,
        attachments: [
          ...state.attachments,
          {
            file_name: fileName,
            attachment_id: fileId,
            succeeded: false,
            file_url: null,
          },
        ],
        chatId:
          currentChatId == null ? payload.response.chat_id : currentChatId,
      }
    case CHECK_ATTACHMENT_STATUS_SUCCESS:
      const chatIdCheck = payload.response.chatId === state.chatId

      if (!chatIdCheck) {
        return state
      }

      return {
        ...state,
        attachments: state.attachments.map(attachment => {
          if (attachment.attachment_id === payload.response.attachmentId) {
            return {
              ...attachment,
              succeeded: payload.response.succeeded,
              file_url: payload.response.fileUrl,
            }
          }
          return attachment
        }),
      }

    case DELETE_CHAT_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachments: state.attachments.filter(
          attachment => attachment.attachment_id !== payload.response,
        ),
      }

    case CHAT_DRAWER_OPEN_SUCCESS:
      return {
        ...state,
        drawerOpen: !state.drawerOpen,
      }

    case SET_CHAT_ID:
      return {
        ...state,
        chatId: payload.chatId,
      }

    case FINAL_TOOL_SUCCESS:
      const finalChat = payload.response
      return {
        ...state,
        chatContent: [...state.chatContent, finalChat],
      }

    case LLM_SET_CHAT_CONTENT:
      return {
        ...state,
        chatContent: [],
      }
    default:
      return state
  }
}
